import { Outlet } from "react-router-dom";
import Header from "../components/header/Header";
import FooterSmall from "../components/footer/FooterSmall";
import UserWelcome from "../features/user/Components/UserWelcome";
import UserSideBar from "../layouts/UserSideBar";
import { useUser } from "../context/User/UserContext";
import { useUserOrder } from "../context/User/UserOrderContext";
import { useUserPayment } from "../context/User/UserPaymentContext";
import { useTranslation } from 'react-i18next';
import { useUserCart } from '../context/User/UserCartContext';
import { useUserFav } from "../context/User/UserFavContext";


export default function UserLayout() {
    const { profile, loading } = useUser();
    const { paidData } = useUserPayment();
    const { cartStats } = useUserCart();
    const { orderData } = useUserOrder();
    const { favBooks } = useUserFav();
    const { t } = useTranslation();

    const paymentCount = paidData?.data?.paginationInfo.totalCount;
    const totalCount = orderData?.data?.paginationInfo.totalCount;
    const FavCount = favBooks?.data?.paginationInfo.totalCount;
    const CartCount = cartStats?.data?.totalBooks + cartStats?.data?.totalApprovedOrders;


    if (loading) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    // if (!profile) return <div className="text-center my-4 text-danger">{t("errorLoadProfile")}</div>;

    return (
        <>
            <Header />
            <main style={{ minHeight: "calc(100vh - 145px)" }}>
                <div className='container dashboard col-12 position-relative d-flex'>
                    <div className='container col-1 col-sm-2 m-0 text-start '>
                        <UserSideBar
                            ordersCount={totalCount}
                            paymentCount={paymentCount}
                            CartCount={CartCount}
                            FavCount={FavCount}
                        />
                    </div>
                    <div className='container mt-4 col-11 col-md-10'>
                        <UserWelcome
                            firstName={profile?.data?.firstName}
                            t={t}
                        />
                        <Outlet />
                    </div>
                </div>
            </main>
            <FooterSmall />
        </>
    );
}